module.exports = __webpack_public_path__ + "static/media/multi_browser.71351f0c.svg";